export default __webpack_public_path__ + "static/mazury-d7eb4ccec1194559296c585349b7db02.jpg";